import SidebarLayout from "@/pages/sidebar/layout";
import DashboardPage from "@/pages/sidebar/dashboard";
import ReviewPage from "@/pages/sidebar/reviews";
import LeadsPage from "@/pages/sidebar/leads";
import EarningsPage from "@/pages/sidebar/earnings";
import NotificationsPage from "@/pages/sidebar/notifications";
import SupportPage from "@/pages/sidebar/support";

// Schedule pages
import CalendarPage from "@/pages/sidebar/schedule/calendar";
// Activated D5 — the richer appointments page with stats tiles,
// server-side pagination, FilterBar (status + advanced filters), search,
// list/grid view toggle, and details linking. Replaces the simpler page
// at @/pages/sidebar/schedule/appointments which previously held this
// route (the simple page is now obsolete).
import AppointmentsPage from "@/pages/sidebar/appointments";
import AppointmentDetailsPage from "@/pages/sidebar/appointments/details";
import AvailabilityPage from "@/pages/sidebar/availability";

// Consultation pages
import CallsPage from "@/pages/sidebar/consultations/calls";
import ChatsPage from "@/pages/sidebar/consultations/chats";
import ClientsPage from "@/pages/sidebar/consultations/clients";

import { profileRoute } from "./profile";
import { interactionRoutes } from "./interact";
import ErrorBoundary from "@/components/ErrorBoundry";

export const sidebarRoutes = {
  path: "/",
  element: <SidebarLayout />,
  errorElement: <ErrorBoundary />,
  children: [
    // Main
    { path: "/", element: <DashboardPage /> },
    
    // Schedule
    { path: "/schedule/calendar", element: <CalendarPage /> },
    { path: "/schedule/appointments", element: <AppointmentsPage /> },
    // Per-appointment details. The page reads :meetingId from URL,
    // fetches the populated Meeting + (for completed) the matching
    // earning ledger row, and renders actions appropriate to status.
    {
      path: "/schedule/appointments/details/:meetingId",
      element: <AppointmentDetailsPage />,
    },
    { path: "/schedule/availability", element: <AvailabilityPage /> },
    
    // Consultations
    { path: "/consultations/calls", element: <CallsPage /> },
    { path: "/consultations/chats", element: <ChatsPage /> },
    { path: "/consultations/clients", element: <ClientsPage /> },
    
    // Leads
    { path: "/leads", element: <LeadsPage /> },
    
    // Account
    { path: "/earnings", element: <EarningsPage /> },
    { path: "/reviews", element: <ReviewPage /> },
    { path: "/notifications", element: <NotificationsPage /> },
    { path: "/support", element: <SupportPage /> },
    
    profileRoute,
    interactionRoutes,
  ],
};
